import { cepService } from 'packages/common/services';
import moment from 'moment';
import employerResource from '../resource';
import { EmployerStore } from '../store';

export function getEstablishment() {
  return employerResource.getEstablishment()
    .then(response => response.data);
}

export function setEstablishment(response) {
  EmployerStore.establishment = response;
}

export function editEstablishment(establishment) {
  return employerResource.editEstablishment(establishment);
}

export function getInscriptionLabel(inscriptionType) {
  switch (inscriptionType) {
  case 'J':
    return 'CNPJ';

  case 'C':
    return 'CAEPF';

  default:
    return 'CNO';
  }
}

export function getCepInformation(cep) {
  return cepService.getCepInformation(cep);
}

export function getCorrectESocialChangeDate(eSocialChangeDate, requireESocialChangeDate) {
  if (!eSocialChangeDate && requireESocialChangeDate) {
    return moment().format('YYYY-MM-DD');
  }

  if (!requireESocialChangeDate) {
    return '';
  }

  return eSocialChangeDate;
}
